export var AppTypes = /*#__PURE__*/ function(AppTypes) {
    AppTypes["auth"] = "Auth Portal";
    AppTypes["client"] = "Client Portal";
    AppTypes["submission"] = "Submission Portal";
    AppTypes["resume"] = "Resume Portal";
    return AppTypes;
}({});
export var MfeTypes = /*#__PURE__*/ function(MfeTypes) {
    MfeTypes["onboarding"] = "onboardingMfe";
    MfeTypes["vendor"] = "vendorMfe";
    MfeTypes["timesheets"] = "timesheetsMfe";
    MfeTypes["scaffold"] = "scaffoldMfe";
    MfeTypes["consultantManagement"] = "consultantManagement";
    return MfeTypes;
}({});
export var SocialLoginType = /*#__PURE__*/ function(SocialLoginType) {
    SocialLoginType["Google"] = "Google";
    SocialLoginType["Facebook"] = "Facebook";
    SocialLoginType["Linkedin"] = "Linkedin";
    SocialLoginType["Microsoft"] = "Portal-Microsoft-SSO";
    return SocialLoginType;
}({});
export var SocialRoutes = /*#__PURE__*/ function(SocialRoutes) {
    SocialRoutes["SocialCallbackURL"] = "signin-social-callback";
    return SocialRoutes;
}({});
export var LoginTypes = /*#__PURE__*/ function(LoginTypes) {
    LoginTypes["Client"] = "Client";
    LoginTypes["Contractor"] = "Contractor";
    LoginTypes["Employer"] = "Employer";
    LoginTypes["Customer"] = "Customer";
    LoginTypes["Support"] = "Support";
    LoginTypes["GorillaResume"] = "GorillaResume";
    return LoginTypes;
}({});
export var ClientNames = /*#__PURE__*/ function(ClientNames) {
    ClientNames["Procom"] = "Procom";
    ClientNames["BMO"] = "Bank of Montreal";
    ClientNames["DemoCorp"] = "DemoCorp";
    ClientNames["DemoClient"] = "Demo Client";
    ClientNames["GwDemoClient"] = "GW Demo Client";
    ClientNames["HCMWorks"] = "HCM Works";
    ClientNames["KPMG"] = "KPMG";
    ClientNames["CENOVUS"] = "Cenovus";
    ClientNames["ProcomTeam"] = "Procom Team";
    ClientNames["Flextrack"] = "Flextrack";
    ClientNames["GorillaWorks"] = "GorillaWorks";
    ClientNames["Symbiotic"] = "Symbiotic";
    ClientNames["Softchoice"] = "Softchoice";
    ClientNames["Demo"] = "Demo";
    ClientNames["DemoSandbox"] = "DemoSandbox";
    ClientNames["EY"] = "EY";
    ClientNames["BridgeView"] = "BridgeView";
    ClientNames["Jarvis"] = "Jarvis";
    return ClientNames;
}({});
export var CompanyNames = /*#__PURE__*/ function(CompanyNames) {
    CompanyNames["ClientConnections"] = "Client Connections";
    return CompanyNames;
}({});
export var ClientCodes = /*#__PURE__*/ function(ClientCodes) {
    ClientCodes["Procom"] = "Procom";
    ClientCodes["BMO"] = "BMO";
    ClientCodes["DemoCorp"] = "DemoCorp";
    ClientCodes["HCMWorks"] = "HCMWorks";
    ClientCodes["KPMG"] = "KPMG";
    ClientCodes["CENOVUS"] = "Cenovus";
    ClientCodes["ProcomTeam"] = "ProcomTeam";
    ClientCodes["Flextrack"] = "Flextrack";
    ClientCodes["Symbiotic"] = "Symbiotic";
    ClientCodes["DemoClient"] = "DemoClient";
    ClientCodes["GwDemoClient"] = "GwDemoClient";
    ClientCodes["EY"] = "EY";
    ClientCodes["IMS"] = "IMS";
    return ClientCodes;
}({});
export var VendorCodes = /*#__PURE__*/ function(VendorCodes) {
    VendorCodes["SFTCHE"] = "SFTCHE";
    VendorCodes["DEMO"] = "DEMO";
    VendorCodes["DEMOSANDBOX"] = "DemoSandbox";
    VendorCodes["GW"] = "GW";
    VendorCodes["IMETHODS"] = "IMETHODS";
    VendorCodes["PCGL"] = "PCGL";
    VendorCodes["Symbiotic"] = "Symbiotic";
    VendorCodes["TSLA"] = "TSLA";
    VendorCodes["BridgeView"] = "BridgeView";
    VendorCodes["Jarvis"] = "Jarvis";
    return VendorCodes;
}({});
export var VendorNames = /*#__PURE__*/ function(VendorNames) {
    VendorNames["GW"] = "GorillaWorks";
    VendorNames["PCGL"] = "Procom Services Ltd";
    VendorNames["TSLA"] = "Tesla Ltd";
    VendorNames["Symbiotic"] = "Symbiotic";
    VendorNames["SFTCHE"] = "Softchoice";
    VendorNames["DEMO"] = "Demo";
    VendorNames["IMETHODS"] = "iMethods";
    VendorNames["DEMOSANDBOX"] = "DemoSandbox";
    VendorNames["BridgeView"] = "BridgeView";
    VendorNames["Jarvis"] = "Jarvis";
    return VendorNames;
}({});
export var IFrameEntityTypes = /*#__PURE__*/ function(IFrameEntityTypes) {
    IFrameEntityTypes["Candidate"] = "Candidate";
    return IFrameEntityTypes;
}({});
export var ClientDomainType = /*#__PURE__*/ function(ClientDomainType) {
    ClientDomainType[ClientDomainType["Local"] = 1] = "Local";
    ClientDomainType[ClientDomainType["Develop"] = 2] = "Develop";
    ClientDomainType[ClientDomainType["Qa"] = 3] = "Qa";
    ClientDomainType[ClientDomainType["Uat"] = 4] = "Uat";
    ClientDomainType[ClientDomainType["Production"] = 5] = "Production";
    return ClientDomainType;
}({});
export var ClientQueryParams = /*#__PURE__*/ function(ClientQueryParams) {
    ClientQueryParams["authPortalRoute"] = "authPortalRoute";
    ClientQueryParams["callbackURL"] = "callbackURL";
    ClientQueryParams["destinationURL"] = "destinationURL";
    ClientQueryParams["originBase"] = "originBase";
    ClientQueryParams["loginType"] = "loginType";
    ClientQueryParams["themeMode"] = "themeMode";
    return ClientQueryParams;
}({});
export var RecaptchaActions = /*#__PURE__*/ function(RecaptchaActions) {
    RecaptchaActions["Signup"] = "signup";
    RecaptchaActions["OpenJobApply"] = "openJobApply";
    RecaptchaActions["ResendInvitation"] = "resendInvitation";
    RecaptchaActions["ActivateFboMapping"] = "activateFboMapping";
    RecaptchaActions["ContractorJobShare"] = "ContractorJobShare";
    RecaptchaActions["GetAnonymousUserInfo"] = "getAnonymousUserInfo";
    RecaptchaActions["RequestResetPassword"] = "requestResetPassword";
    RecaptchaActions["ClaimContractorProfile"] = "claimContractorProfile";
    RecaptchaActions["ContractorProfileInfo"] = "contractorProfileInfo";
    RecaptchaActions["DeclineContractorProfile"] = "declineContractorProfile";
    RecaptchaActions["Mfa"] = "AddOrRemoveMfa";
    RecaptchaActions["CodeSignIn"] = "codeSignin";
    RecaptchaActions["GetRestrictedAccessCode"] = "getRestrictedAccessCode";
    RecaptchaActions["GuestSignIn"] = "guestSignin";
    RecaptchaActions["ValidateEmailDomain"] = "validateEmailDomain";
    RecaptchaActions["LanguageCopilot"] = "languageCopilot";
    return RecaptchaActions;
}({});
export var CommonMessages = /*#__PURE__*/ function(CommonMessages) {
    CommonMessages["SomethingWrong"] = "somethingWrong";
    CommonMessages["LoginFailed"] = "loginFailed";
    CommonMessages["InvalidEmailDomain"] = "invalidEmailDomain";
    return CommonMessages;
}({});
export var AuthPortalRouteMaps = /*#__PURE__*/ function(AuthPortalRouteMaps) {
    AuthPortalRouteMaps["Login"] = "login";
    AuthPortalRouteMaps["Signup"] = "signup";
    AuthPortalRouteMaps["SignupEmail"] = "signupEmail";
    AuthPortalRouteMaps["ResetExpiredPassword"] = "resetExpiredPassword";
    AuthPortalRouteMaps["VerifyEmail"] = "verifyEmail";
    AuthPortalRouteMaps["ResetPassword"] = "resetPassword";
    return AuthPortalRouteMaps;
}({});
export var AiFeatureLocations = /*#__PURE__*/ function(AiFeatureLocations) {
    AiFeatureLocations["ClientPortal"] = "Client Portal";
    AiFeatureLocations["EmployerPortal"] = "Employer Portal";
    AiFeatureLocations["Bullhorn"] = "Bullhorn";
    return AiFeatureLocations;
}({});
export var PortalType = /*#__PURE__*/ function(PortalType) {
    PortalType["CLIENT"] = "client";
    PortalType["EMPLOYER"] = "employer";
    return PortalType;
}({});
export var EmailSupportLinks = /*#__PURE__*/ function(EmailSupportLinks) {
    EmailSupportLinks["ClientConnections"] = "info@clientconnections.com";
    EmailSupportLinks["GorillaWorks"] = "contact@gorillaworks.io";
    return EmailSupportLinks;
}({});
export var InterviewPlatforms = /*#__PURE__*/ function(InterviewPlatforms) {
    InterviewPlatforms["Zoom"] = "Zoom";
    InterviewPlatforms["MicrosoftTeams"] = "Microsoft Teams";
    InterviewPlatforms["InPerson"] = "In Person";
    InterviewPlatforms["Other"] = "Other";
    return InterviewPlatforms;
}({});
export var ContractorSignupTypes = /*#__PURE__*/ function(ContractorSignupTypes) {
    ContractorSignupTypes["Email"] = "email";
    ContractorSignupTypes["OneTimeCode"] = "one-time-code";
    ContractorSignupTypes["Google"] = "google";
    ContractorSignupTypes["Facebook"] = "facebook";
    ContractorSignupTypes["LinkedIn"] = "LinkedIn";
    return ContractorSignupTypes;
}({});
export var SocialLoginContext = /*#__PURE__*/ function(SocialLoginContext) {
    SocialLoginContext["Signup"] = "signup";
    SocialLoginContext["Login"] = "login";
    return SocialLoginContext;
}({});
